import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet'
import { sampleBanner, checkIconW, sampleIntro1, sampleIntro2, sampleIntro3 } from '../../resources/images'

class Home extends Component {
    constructor(props) {
        super(props);
        // this.onCalcFare = debounce(this.onCalcFare, 500)
        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <Fragment>
                <Helmet>
                    <title>QBank Landing Page</title>
                    <meta name="description" content="QBank landing allow user to know more about QBank Company background and also QBank products" />
                </Helmet>
                <div className="homePage">
                    <div className="bannerCont">
                        <img src={sampleBanner} alt="Banner Image 1" className="qbBanner" />
                        <div className="descBox">
                            <div className="fTitle">USMLE® STEP 1 QBANK</div>
                            <div className="fDisplay">NOW WITH 3,300+<br />TEST-LIKE QUESTIONS</div>
                            <div className="fCaption">USMLE® STEP 1 QBANK</div>
                        </div>
                    </div>
                    <div className="bodyCont">
                        <div className="subscribeCont">
                            <div className="titleBox">
                                <div className="fDisplay">QBank</div>
                                <div className="fTitle seperator">|</div>
                                <div className="fTitle">From $99</div>
                            </div>
                            <div className="actionBox">
                                <div className="qbBtn" onClick={() => this.props.history.push('/signup')}>Try For Free</div>
                                <div className="qbBtn solid" onClick={() => this.props.history.push('/pricing')}>Buy</div>
                            </div>
                        </div>
                        <div className="qbRow">
                            <div className="itemBox">
                                <div className="fDisplay">ALWAYS AT THE<br />CUTTING EDGE</div>
                                <div className="fBody">We constantly update our content, images, and questions so you can stay ahead of the curve.</div>
                            </div>
                            <div className="itemBox">
                                <div className="fDisplay">LEARN FROM<br />YOUR MISTAKES</div>
                                <div className="fBody">Detailed review materials help you boost your score and keep on boosting it.</div>
                            </div>
                            <div className="itemBox">
                                <div className="fDisplay">LEARN THE TEST WITH<br />REALISTIC PRACTICE</div>
                                <div className="fBody">A test-like interface with 3,300+ questions means that  you’ll get the hang of the exam before test day.</div>
                            </div>
                        </div>
                        <div className="infoCont">
                            <div className="itemCont">
                                <div className="checkBox">
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">Over 3,300+ exam-like questions</div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">Step-by-step strategies</div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">Interface that replicates the actual Step 1</div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">Succinct answer explanations</div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">3D BioDigital images and animations</div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">Instructive videos by Dr. Armando</div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">2 full-length simulated exams</div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">Detailed progress reports</div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">Access via Kaplan app</div>
                                    </div>
                                </div>
                            </div>
                            <div className="itemCont">
                                <img src={sampleIntro1} alt="Introduction Image 1" className="qbImg" />
                            </div>
                        </div>
                        <div className="infoCont">
                            <div className="itemCont">
                                <div className="fDisplay">GET STRATEGIC</div>
                                <div className="fBody">Step-by-step strategies walk you through each question, so you can think like a physician. Review in-depth explanations and master the material.</div>
                            </div>
                            <div className="itemCont">
                                <div className="checkBox">
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">What's the question asking?</div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">What relevant information is there?</div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">What's is underlying concept?</div>
                                    </div>
                                    <div className="qbRow">
                                        <div className="checkBtn">
                                            <img src={checkIconW} alt="Checkbox Icon" className="qbIcon" />
                                        </div>
                                        <div className="fLabel">Can other answer be eliminated?</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="infoCont">
                            <div className="itemCont">
                                <img src={sampleIntro2} alt="Introduction Image 2" className="qbImg" />
                            </div>
                            <div className="itemCont">
                                <div className="fDisplay">“TOO REAL.” AS IF<br />THAT’S A BAD THING.</div>
                                <div className="fBody">The best way to tackle USMLE® Step 1? With the Step 1 interface, now in our Qbank. It replicates the actual exam—format, questions and all—to a T.</div>
                            </div>
                        </div>
                        <div className="infoCont">
                            <div className="itemCont">
                                <div className="fDisplay">UP CLOSE AND<br />PERSONAL</div>
                                <div className="fBody">3D animations and images make big concepts to life. Zoom in. Pan around. Learn by exploring the body, inside out.</div>
                            </div>
                            <div className="itemCont">
                                <img src={sampleIntro3} alt="Introduction Image 3" className="qbImg" />
                            </div>
                        </div>
                    </div>
                    <div className="promoCont">
                        <div className="fDisplay">AMA MEMBERS SAVE 30%*</div>
                        <div className="fCaption">Use your AMA medical education number when you enroll online.</div>
                        <div className="fDesc">*Have your Medical Education Number (ME#) handy (located on your AMA ID card). If you don't have it, call the AMA Customer Service at 1-800-262-3211. The 30% discount will automatically apply to all eligible courses. An active AMA membership is required to qualify for the course discount. Course discount is subject to verification of AMA membership and cannot be applied retroactively to an existing enrollment.<br /><br />Not an AMA member? Enroll today at <span className="fLink" onClick={() => window.open("https://www.ama-assn.org/", '_blank')}>www.ama-assn.org</span>.</div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ }) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));


// WEBPACK FOOTER //
// ./src/Components/home/Home.js